import api from '../api/axiosClient';

export interface Plan {
  planId: number;
  planName: string;
  description: string;
  price: number;
  durationInDays: number;
  isActive: boolean;
  isDefault: boolean;
  createdDate: string;
  updatedDate?: string;
}

export type PlanUpsert = Omit<Plan, 'planId' | 'createdDate' | 'updatedDate'> & Partial<Pick<Plan, 'isDefault' | 'isActive'>>;

const BASE = '/admin/plans';

export const getPlans = async (): Promise<Plan[]> => {
  const res = await api.get<Plan[]>(BASE);
  return res.data;
};

// Get active plans for public signup flow
export const getActivePlans = async (): Promise<Plan[]> => {
  try {
    // Try public endpoint first
    const res = await api.get<Plan[]>('/plans?active=true');
    return res.data;
  } catch (error) {
    // Fallback to admin endpoint and filter on frontend
    const res = await api.get<Plan[]>(BASE);
    return res.data.filter(plan => plan.isActive);
  }
};

export const createPlan = async (data: PlanUpsert): Promise<Plan> => {
  const res = await api.post<Plan>(BASE, data);
  return res.data;
};

export const updatePlan = async (id: number, data: PlanUpsert): Promise<Plan> => {
  const res = await api.put<Plan>(`${BASE}/${id}`, data);
  return res.data;
};

export const togglePlanStatus = async (id: number): Promise<Plan> => {
  const res = await api.patch<Plan>(`${BASE}/${id}/status`);
  return res.data;
};

export const setDefaultPlan = async (id: number): Promise<Plan> => {
  const res = await api.patch<Plan>(`${BASE}/${id}/set-default`);
  return res.data;
};

export const getPlan = async (id: number): Promise<Plan> => {
  const res = await api.get<Plan>(`${BASE}/${id}`);
  return res.data;
};
